import { HttpClient, HttpEventType } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { PageEvent } from '@angular/material/paginator'
import { Filesystem, Directory, FileInfo, ReaddirResult } from '@capacitor/filesystem'
import write_blob from 'capacitor-blob-writer'
import { AlertController, LoadingController, ModalController } from '@ionic/angular/standalone'
import { take } from 'rxjs/operators'
import { AuthService } from 'src/app/core/auth.service'
import { FileProcessingService } from 'src/app/services/file-processing.service'
import { config } from 'src/environments/environment'

import { Preferences } from '@capacitor/preferences'
import { ConsoleLogService } from 'src/app/services/console-log.service'
import { MessageService } from 'primeng/api'
import { CacheManagementService } from 'src/app/services/cache-management.service'

@Component({
  selector: 'app-debug-view',
  templateUrl: './debug-view.page.html',
  styleUrls: ['./debug-view.page.scss'],
  standalone: false,
})
export class DebugViewPage implements OnInit {
  dirData: ReaddirResult
  dirDataFiltered: ReaddirResult
  dirCache: ReaddirResult
  dirDoc: ReaddirResult
  dirExt: ReaddirResult
  dirExtStorage: ReaddirResult
  dirLibrary: ReaddirResult
  dirDcim: ReaddirResult
  uploadProgress: number
  lowValue: number = 0
  highValue: number = 100000

  foundFileIds = []

  keys: string[] = []
  foundKeyValues: keyValue[] = []
  uuidFoldersToDelete: string[] = []

  constructor(
    private http: HttpClient,
    public modalController: ModalController,
    public alertController: AlertController,
    private fileProcessing: FileProcessingService,
    public loadingController: LoadingController,
    private consoleLogsServices: ConsoleLogService,
    private messageService: MessageService,
    private fileProcessingService: FileProcessingService,
    private auth: AuthService,
    private cacheManagementService: CacheManagementService
  ) {}

  async ngOnInit() {
    this.getDataDir()
    this.getPreferencesData()
  }

  async getPreferencesData() {
    this.keys = await (await Preferences.keys()).keys
    for await (const key of this.keys) {
      const val = (await Preferences.get({ key: key })).value
      const keyVal: keyValue = { key: key, value: val! }
      console.log(keyVal)

      this.foundKeyValues.push(keyVal)
    }
  }

  async checkValidFile(file: FileInfo, execute: boolean = false) {
    let totalFixed = 0
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Checking files...',
      duration: 20000,
    })
    await loading.present()

    const errorMsg = execute ? 'Fixed ' : 'Found '

    const files = await this.getCurrentDocs()

    // check file has underscore which means it was created by the app
    const res = await this.corruptFileProcess(file, files, execute)
    if (res === 'fixed') {
      totalFixed++
      loading.message = errorMsg + totalFixed + ' files...'
    }

    this.messageService.add({ severity: 'error', summary: 'Fix', detail: 'Found ' + totalFixed + ' corrupt files', sticky: true })
    // await this.outputSavedDocs()
    loading.dismiss()
    if (execute) {
      this.getDataDir()
    }
  }

  async checkValidFiles(data: ReaddirResult, execute: boolean = false) {
    let totalFixed = 0
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Checking files...',
      duration: 20000000,
    })
    await loading.present()
    const errorMsg = execute ? 'Fixed ' : 'Found '

    try {
      const files = await this.getCurrentDocs()
      for await (const file of data.files) {
        // check file has underscore which means it was created by the app
        const res = await this.corruptFileProcess(file, files, execute)
        if (res === 'fixed') {
          totalFixed++
          loading.message = errorMsg + totalFixed + ' files...'
        }
      }

      this.messageService.add({ severity: 'error', summary: 'Fix', detail: 'Found ' + totalFixed + ' corrupt files', sticky: true })
      // await this.outputSavedDocs()
      loading.dismiss()
      this.getDataDir()
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Fix error', detail: 'Issue with bulk check - ' + error, sticky: true })
      loading.dismiss()
    }
  }

  async corruptFileProcess(file: FileInfo, files: FileInfo[], execute: boolean = false) {
    if (file.name.split('_').length > 1) {
      try {
        const readFile = await Filesystem.readFile({
          path: file.uri,
        })
        // Read base64 image to check file type
        const base64Image = this.fileProcessingService.b64toBlob(readFile.data)
        // get actual corrupt file
        const externalFile = await this.getDataFile(file.name)
        console.log('checkValidFiles3', externalFile)
        if (base64Image.type === '' && externalFile !== null && externalFile?.ctime && externalFile.ctime >= 0) {
          // find file created within 5 seconds of corrupt file
          const matchingFile = structuredClone(files).filter(
            (f) => externalFile.ctime !== undefined && f.ctime! > externalFile.ctime - 7000 && f.ctime! < externalFile.ctime + 1000
          )
          if (matchingFile.length > 0) {
            // read good file
            const goodFile = await Filesystem.readFile({
              directory: Directory.ExternalStorage,
              path: 'DCIM/' + matchingFile[0].name,
            }).catch((err) => {
              console.log('read good file error', err)
            })

            if (goodFile) {
              // delete corrupt file
              try {
                if (execute) {
                  // await Filesystem.deleteFile({
                  //   directory: Directory.Data,
                  //   path: file.name,
                  // }).catch((err) => {
                  //   console.log('deleteFile error', err)
                  // })
                  const newFileName = file.uri + '.corrupt'
                  await Filesystem.rename({
                    from: file.uri,
                    to: newFileName,
                  })
                  // write goodFile to replace corrupt
                  await write_blob({
                    path: file.name,
                    directory: Directory.Data,
                    blob: this.fileProcessing.b64toBlob(goodFile.data),
                    recursive: true,
                    on_fallback(err) {
                      console.log('write good file error', err)
                      return true
                    },
                  })
                }
                return 'fixed'
              } catch (err) {
                this.consoleLogsServices.addConsoleLog('Fix corrupt file', JSON.stringify(err), 'danger', 'corruptFileProcess:175')
                return 'goodFileError'
              }
            }
          } else {
            this.consoleLogsServices.addConsoleLog(
              'Files within 15s ',
              structuredClone(files)
                .filter((f) => externalFile.ctime !== undefined && f.ctime! > externalFile.ctime - 15000 && f.ctime! < externalFile.ctime + 1000)
                .length.toString(),
              'danger',
              'checkValidFiles:120'
            )
            return 'matchingFileError'
          }
        }
      } catch (error) {
        this.consoleLogsServices.addConsoleLog('Fix corrupt file', JSON.stringify(error), 'danger', 'corruptFileProcess:192')
        return 'fileError'
      }
    }
    return 'splitError'
  }

  async deleteCorruptFiles(data: ReaddirResult) {
    const alert = await this.alertController.create({
      header: 'Delete corrupt files?',
      message: 'Would you like to proceed?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel: blah')
          },
        },
        {
          text: 'Okay',
          handler: async () => {
            await this.deleteCorruptFilesAction(data)
            return true
          },
        },
      ],
    })

    await alert.present()
  }

  async deleteCorruptFilesAction(data: ReaddirResult) {
    let totalDeleted = 0
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Deleting files...',
      duration: 20000,
    })
    await loading.present()
    for await (const file of data.files) {
      if (file.name.split('.corrupt').length > 1) {
        await Filesystem.deleteFile({
          directory: Directory.Data,
          path: file.name,
        }).catch((err) => {
          console.log('deleteFile error', err)
        })
        totalDeleted++
      }
    }
    this.messageService.add({ severity: 'error', summary: 'Fix', detail: 'Deleted ' + totalDeleted + ' corrupt files', sticky: true })
    loading.dismiss()
    this.getDataDir()
  }

  async getDataFile(filename: string) {
    const dir = await Filesystem.readdir({ path: '', directory: Directory.Data })
    // console.log('outputCurrentDocs', dir);
    for await (const file of dir.files) {
      // console.log(file);
      if (file.name === filename) {
        return file
      }
    }
    return null
  }

  async getExternalStorageFile(filename: string) {
    const dir = await Filesystem.readdir({ path: 'DCIM', directory: Directory.ExternalStorage })
    // console.log('outputCurrentDocs', dir);
    for await (const file of dir.files) {
      // console.log(file);
      if (file.name === filename) {
        return file
      }
    }
    return null
  }

  async getCurrentDocs() {
    const files: FileInfo[] = []
    const dir = await Filesystem.readdir({ path: 'DCIM', directory: Directory.ExternalStorage })
    // console.log('outputCurrentDocs', dir);
    for await (const file of dir.files) {
      // console.log(file);
      files.push(file)
    }
    console.log('files', files)
    return files
  }

  async outputSavedDocs() {
    const dir = await Filesystem.readdir({ path: '', directory: Directory.Data })
    console.log('outputSavedDocs', dir)
    for await (const file of dir.files) {
      console.log(file)
    }
  }

  async outputCurrentDocs() {
    const dir = await Filesystem.readdir({ path: 'DCIM', directory: Directory.ExternalStorage })
    console.log('outputCurrentDocs', dir)
    for await (const file of dir.files) {
      console.log(file)
    }
  }

  async getDataDir() {
    await Filesystem.requestPermissions()
    this.dirData = await Filesystem.readdir({ path: '', directory: Directory.Data })
    this.dirDataFiltered = structuredClone(this.dirData)
    try {
      this.dirCache = await Filesystem.readdir({ path: '', directory: Directory.Cache })
    } catch (error) {
      this.consoleLogsServices.addConsoleLog('getDataDir', JSON.stringify(error), 'danger', 'getDataDir:dirCache')
    }
    try {
      this.dirDoc = await Filesystem.readdir({ path: '', directory: Directory.Documents })
    } catch (error) {
      this.consoleLogsServices.addConsoleLog('getDataDir', JSON.stringify(error), 'danger', 'getDataDir:dirDoc')
    }
    try {
      this.dirExt = await Filesystem.readdir({ path: '', directory: Directory.External })
    } catch (error) {
      this.consoleLogsServices.addConsoleLog('getDataDir', JSON.stringify(error), 'danger', 'getDataDir:dirExt')
    }
    try {
      this.dirExtStorage = await Filesystem.readdir({ path: '', directory: Directory.ExternalStorage })
    } catch (error) {
      this.consoleLogsServices.addConsoleLog('getDataDir', JSON.stringify(error), 'danger', 'getDataDir:dirExtStorage')
    }
    try {
      this.dirDcim = await Filesystem.readdir({ path: 'DCIM', directory: Directory.ExternalStorage })
    } catch (error) {
      this.consoleLogsServices.addConsoleLog('getDataDir', JSON.stringify(error), 'danger', 'getDataDir:dirDcim')
    }
    try {
      this.dirLibrary = await Filesystem.readdir({ path: '', directory: Directory.Library })
    } catch (error) {
      this.consoleLogsServices.addConsoleLog('getDataDir', JSON.stringify(error), 'danger', 'getDataDir:dirLibrary')
    }
    console.log(this.dirData, this.dirCache, this.dirDoc, this.dirExt, this.dirExtStorage, this.dirLibrary)
  }

  async autoProc(file: FileInfo) {
    const idToken = await this.auth.getValidToken()
    console.log('autoProc', file.name)

    let fileExists: any

    // check file doesn't exist on Azure storage
    let fileReturn = await this.http
      .get(config.filesApiUrl, {
        params: {
          name: file.name,
        },
        headers: {
          Authorization: 'Bearer ' + idToken,
          'x-api-version': '1.0',
        },
      })
      .pipe(take(1))
      .toPromise()
      .catch((err) => {
        console.log('file not found', file.name, err)
        fileExists = false
      })
    console.log('checkFileExists', fileExists, fileReturn)

    // if not found, upload
    if (fileExists === false && fileReturn === undefined) {
      console.log('upload file', file.name)
      await this.uploadFileSingle(file)
    }

    // check file has been uploaded
    fileReturn = await this.http
      .get(config.filesApiUrl, {
        params: {
          name: file.name,
        },
        headers: {
          Authorization: 'Bearer ' + idToken,
          'x-api-version': '1.0',
        },
      })
      .pipe(take(1))
      .toPromise()
      .catch((err) => {
        console.log('file not found pt2', file.name, err)
        fileExists = false
      })
    console.log('checkFileExists', fileReturn)

    // if found on Azure storage, process
    if (fileReturn !== undefined) {
      console.log('delete file', file.name)
      await this.deleteFile(file.name)
    }
  }

  async auto() {
    if (this.dirData.files.length > 0) {
      const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Processing file...',
        duration: 20000,
      })
      await loading.present()

      for await (const [i, file] of this.dirData.files.entries()) {
        loading.message = 'Processing file ' + i
        console.log('Processing file', i, file)
        await this.autoProc(file)
      }

      loading.dismiss()
    }
  }

  async checkFileExists(file: FileInfo, auto: boolean = false): Promise<boolean> {
    console.log('check file exists', file.name)
    const idToken = await this.auth.getValidToken()
    await this.http
      .get<boolean>(config.filesApiUrl, {
        params: {
          name: file.name,
        },
        headers: {
          Authorization: 'Bearer ' + idToken,
          'x-api-version': '1.0',
        },
      })
      .subscribe(
        async (data) => {
          console.log('file exists', data)
          // this.foundFileIds.push(file.name);
          const alert = await this.alertController.create({
            header: 'File exists',
            message: 'Would you like to delete it?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                  console.log('Confirm Cancel: blah')
                },
              },
              {
                text: 'Okay',
                handler: async () => {
                  await this.deleteFile(file.name)
                  return true
                },
              },
            ],
          })

          await alert.present()
          // this.dataStore.messages = data;
          // this._messages.next(this.dataStore.messages);
        },
        async (err) => {
          console.log("file doesn't exist", err)
          const alert = await this.alertController.create({
            header: 'File not found',
            message: 'Would you like to upload it?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                  console.log('Confirm Cancel: blah')
                },
              },
              {
                text: 'Okay',
                handler: async () => {
                  await this.uploadFile(file, auto)
                },
              },
            ],
          })

          await alert.present()
        }
      )
    console.log('checkFileExists false')
    return false
  }

  async uploadFileSingle(file: FileInfo) {
    console.log('upload file start', file.name)

    const readFile = await Filesystem.readFile({ path: file.name, directory: Directory.Data })

    const fileBlob = this.fileProcessing.b64toBlob(readFile.data, file.type)
    const fileGuid = file.name.split('_')[0]
    const fileName = file.name.replace(fileGuid + '_', '')
    const formData = new FormData()
    formData.append('id', fileGuid)
    formData.append('file', fileBlob, file.name)
    formData.append('FileName', file.name)
    formData.append('FileDisplayName', fileName)
    formData.append('OwnerProfileId', this.auth.getCurrentUserId())
    formData.append('FileType', file.type)
    const thumbnail = 'thumbnail/' + file.name
    formData.append('Thumbnail', thumbnail)

    const token = await this.auth.getValidToken()

    await this.http
      .post(config.filesApiUrl, formData, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .pipe(take(1))
      .toPromise()
      .catch((err) => {
        console.log('upload file error', err)
      })
    console.log('upload file finish', file.name)
  }

  async uploadFile(file: FileInfo, auto: boolean = false) {
    console.log('upload file', file.name)

    const readFile = await Filesystem.readFile({ path: file.name, directory: Directory.Data })

    // Get a reference to the file that has just been added to the input
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Processing file...',
      duration: 20000,
    })
    await loading.present()

    // const idx = file.name.lastIndexOf('.');
    // const fileExt = file.name.substring(idx + 1);
    // var b64file = `data:image/${fileExt};base64,${readFile.data}`;

    const fileBlob = this.fileProcessing.b64toBlob(readFile.data, file.type)

    const fileGuid = file.name.split('_')[0]
    const fileName = file.name.replace(fileGuid + '_', '')

    const formData = new FormData()
    formData.append('id', fileGuid)
    formData.append('file', fileBlob, file.name)
    formData.append('FileName', file.name)
    formData.append('FileDisplayName', fileName)
    formData.append('OwnerProfileId', this.auth.getCurrentUserId())
    formData.append('FileType', file.type)

    const thumbnail = 'thumbnail/' + file.name

    formData.append('Thumbnail', thumbnail)

    const token = await this.auth.getValidToken()

    await this.http
      .post(config.filesApiUrl, formData, {
        reportProgress: true,
        observe: 'events',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .subscribe(
        async (event: any) => {
          console.log(event)
          if (event.type == HttpEventType.UploadProgress) {
            this.uploadProgress = Math.round(100 * (event.loaded / event.total))
            console.log(this.uploadProgress)
            loading.message = 'Processed: ' + this.uploadProgress + '%'
          }

          if (event.type == HttpEventType.Response) {
            loading.dismiss()
            await this.checkFileExists(file, auto)
          }
        },
        async (err) => {
          console.error(err)

          loading.dismiss()
          const alert = await this.alertController.create({
            header: 'Error',
            message: 'Sorry, there was an error uploading your file. Delete the file?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                  console.log('Confirm Cancel: blah')
                },
              },
              {
                text: 'Okay',
                handler: async () => {
                  await this.deleteFile(file.name)
                  return true
                },
              },
            ],
          })

          await alert.present()
        }
      )
  }

  async deleteFile(name: string) {
    console.log('delete file', name)
    await Filesystem.deleteFile({
      path: name,
      directory: Directory.Data,
    })
      .then(() => {
        console.log('file deleted')
        this.getDataDir()
      })
      .catch((err) => {
        console.log('file not deleted', err)
      })
  }
  setFilteredItems(ev: any) {
    const query = ev.target.value.toLowerCase()
    console.log('setFilteredItems', ev)
    this.dirDataFiltered = structuredClone(this.dirData)
    this.dirDataFiltered.files = this.dirData.files.filter((file) => file.name.includes(query))
  }

  async scanCacheForUuidFolders() {
    try {
      this.uuidFoldersToDelete = await this.cacheManagementService.scanForUuidFolders()

      if (this.uuidFoldersToDelete.length === 0) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Cache Directory',
          detail: 'No UUID folders found in cache',
          sticky: true,
        })
        return
      }

      this.messageService.add({
        severity: 'success',
        summary: 'Scan Complete',
        detail: `Found ${this.uuidFoldersToDelete.length} UUID folders in Cache directory`,
        sticky: true,
      })

      console.log('UUID folders found:', this.uuidFoldersToDelete)
    } catch (error) {
      this.consoleLogsServices.addConsoleLog('scanCacheForUuidFolders', JSON.stringify(error), 'danger', 'scanCacheForUuidFolders')
      this.messageService.add({
        severity: 'error',
        summary: 'Scan Error',
        detail: 'Error scanning Cache directory for UUID folders',
        sticky: true,
      })
    }
  }

  async deleteUuidFolders() {
    if (this.uuidFoldersToDelete.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Folders',
        detail: 'No UUID folders to delete. Run scan first.',
        sticky: true,
      })
      return
    }

    const alert = await this.alertController.create({
      header: 'Delete UUID Folders?',
      message: `Are you sure you want to delete ${this.uuidFoldersToDelete.length} UUID folders from Cache?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Delete cancelled')
          },
        },
        {
          text: 'Delete',
          handler: async () => {
            await this.deleteUuidFoldersAction()
            return true
          },
        },
      ],
    })

    await alert.present()
  }

  async deleteUuidFoldersAction() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Deleting UUID folders...',
      duration: 60000,
    })
    await loading.present()

    const result = await this.cacheManagementService.deleteUuidFolders(this.uuidFoldersToDelete, (deleted, total) => {
      loading.message = `Deleted ${deleted}/${total} folders...`
    })

    // Log any failures
    if (result.failedFolders.length > 0) {
      for (const folderName of result.failedFolders) {
        this.consoleLogsServices.addConsoleLog('deleteUuidFoldersAction', `Failed to delete ${folderName}`, 'danger', 'deleteUuidFoldersAction')
      }
    }

    loading.dismiss()

    this.messageService.add({
      severity: result.totalFailed > 0 ? 'warn' : 'success',
      summary: 'Deletion Complete',
      detail: `Deleted ${result.totalDeleted} folders. Failed: ${result.totalFailed}`,
      sticky: true,
    })

    // Clear the list and refresh directory view
    this.uuidFoldersToDelete = []
    await this.getDataDir()
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    })
  }
  public getPaginatorData(event: PageEvent): PageEvent {
    this.lowValue = event.pageIndex * event.pageSize
    this.highValue = this.lowValue + event.pageSize
    return event
  }
}
export interface keyValue {
  key: string
  value: string
}
